import moment from 'moment';
import {
  BaseModel,
} from '../models';

const formatDate = (date) => {
  const datetransform = date.split('::').map((filterValue) => moment(filterValue, 'DD/MM/YYYY').unix());
  if (datetransform.length === 2) {
    return {
      $gte: datetransform[0],
      $lte: datetransform[1],
    };
  }
  return {
    $gte: datetransform[0],
  };
};

export default class Filter extends BaseModel {
  constructor(data = {}) {
    super(data);

    const filterObject = {};

    if (data.search != null) {
      filterObject.$or = ['summary', 'description', 'ref_num'].map((key) => ({
        [key]: {
          $regex: `%${data.search.toUpperCase()}%`,
        },
      }));
    }

    if (data.status != null) {
      if (Array.isArray(data.status) && data.status.length > 1) {
        filterObject.status = {
          $in: data.status,
        };
      } else {
        filterObject.status = data.status;
      }
    }

    if (data.type != null) {
      if (Array.isArray(data.type) && data.type.length > 1) {
        filterObject.type = {
          $in: data.type,
        };
      } else {
        filterObject.type = data.type;
      }
    }

    if (data.customer != null) {
      filterObject.customer = data.customer;
    }

    if (data.open_date != null) {
      filterObject.open_date = formatDate(data.open_date);
    }

    if (data.resolve_date != null) {
      filterObject.resolve_date = formatDate(data.resolve_date);
    }

    if (data.close_date != null) {
      filterObject.close_date = formatDate(data.close_date);
    }

    if (data.priority != null) {
      if (data.priority.length > 1) {
        filterObject.priority = {
          $in: data.priority,
        };
      } else {
        filterObject.priority = data.priority;
      }
    }

    this.filterObject = filterObject;
  }

  toFilterObject() {
    return {
      $and: Object.keys(this.filterObject).map((key) => ({
        [key]: this.filterObject[key],
      })),
    };
  }
}

export const formatFilter = (data) => new Filter(data).toFilterObject();

/* ({
  $and: Object.keys(data)
    .map((filterKey) => {
      if (filterKey === 'search') {
        const search =;
        return search;
      } if (Array.isArray(data[filterKey])) {
        const searchInarray = { [filterKey]: { $in: data[filterKey] } };
        return searchInarray;
      } if (data[filterKey].includes('-')) {
        const filter = data[filterKey].split('-');
        const date1 = filter[0].replace(/ /g, '').split('/');
        const date2 = filter[1].replace(/ /g, '').split('/');
        const dateformat1 = `${date1[2]}-${date1[1]}-${date1[0]}`;
        const dateformat2 = `${date2[2]}-${date2[1]}-${date2[0]}`;
        // const search1 = { [filterKey]: { $gte: new Date(dateformat1).getTime() / 1000 } };
        // const search2 = { [filterKey]: { $lte: new Date(dateformat2).getTime() / 1000 } };
        // query.$and.push(search1);
        // query.$and.push(search2);
        return {
          [filterKey]: {
            $gte: new Date(dateformat1).getTime() / 1000,
            $lte: new Date(dateformat2).getTime() / 1000,
          },
        };
      } if (data[filterKey].includes('/')) {
        const date = data[filterKey].split('/');
        const dateformat = `${date[2]}-${date[1]}-${date[0]}`;
        const search = { [filterKey]: { $gte: new Date(dateformat).getTime() } };
        return search;
      }
      return { [filterKey]: data[filterKey] };
    }),
}); */
